import { Box, styled } from '@mui/material';

export const StyledLayout = styled(Box)`
  display: flex;
  min-height: 100%;
`;
